import type { UserInvitationVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveUserInvitations = createApiThunk<UserInvitationVM[], void>(
  "users/retrieveUserInvitations",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listUserInvitations();
  },
);
